import styled, { css } from 'styled-components'

import { artefactColors } from 'constants/color'
import { isIPad } from 'utils/device'

export const Wrapper = styled.div`
    height: 100vh;
    width: 100vw;
    display: grid;
    grid-template-rows: min-content 1fr;
    background-color: ${({ isQuizMode }) =>
        isQuizMode && isIPad ? artefactColors.quiz : '#222'};

    @media only screen and (orientation: landscape) {
        grid-template-columns: 1fr 6fr;
        grid-template-rows: unset;
        direction: rtl;
    }
`

export const ParticipantWrapper = styled.span`
    width: 100%;
    ${props =>
        props.faded &&
        css`
            opacity: 0.2;
        `}
`
